import React from 'react'
import ScrollToTop from "react-scroll-to-top";
import { SlArrowUp } from "react-icons/sl";
const ScrollToTopSection = () => {
  return (
    <>
        <div>
      <ScrollToTop
        smooth
        component={<SlArrowUp />}
        style={{
          backgroundColor: 'var(--primary)',
          right: 40,
          bottom: 40,
          position: 'fixed',
          zIndex: 2,
          cursor: 'pointer',
          borderRadius: 0,
          width: 40,
          height: 40,
          color:'var(--white)',
          border: '1px solid var(--white)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      />
    </div>
    </>
    
  )
}

export default ScrollToTopSection
